<template>
  <section  id="truck-system">
    <main style="text-align:left;white-space:normal">
      <div v-if="!currentShipment">
        <div class="title">
          <icon icoClass='title-ico' selected='trucks'/>
          {{ $t('search') }}
        </div>
        <div class="fields">
          <div class="field">
            <label>{{ $t('load') }} / {{ $t('download') }}</label>
            <span class="custom-dropdown"><select v-model="shipment.type">
            <option v-for="(type, index) in types" :key="index" :value="type.id">
              {{ $t(type.name) }}
            </option>
            </select></span>
          </div>
          <div class="field">
            <label>{{ $t('search_delivery') }}</label>
            <input type="text" v-model="shipment.reference" style="width:100%; box-sizing:border-box" />
          </div>
          <button class="btn-green" @click="existShipment()">{{ $t('validate') }}</button>
          <button class="btn-black" @click="$emit('cancel')">{{ $t('cancel') }}</button>
        </div>
      </div>
      <div v-else>
        <add-truck @cancel="currentShipment=undefined, shipment={}" @save="updateShipment($event)"/>
      </div>
    </main>
    <modal v-if="infoShipper">
      <div slot="body">
        <label class="title">{{ $t('info') }}</label><hr/>
        <label style="font-size: 3em; padding: 5px; padding-top: 0px;"><pre>{{ info }}</pre></label>
        <div class="buttons"  style="margin: auto;">
          <button class="button btn-green" style="font-size: 1em; margin: 0 auto;" @click="infoShipper=false">{{ $t('accept') }}</button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import AddTruck from './../components/Truck'
import Modal from './../components/Modal'
import Icon from './../svg/tabs'
import {mapActions} from 'vuex'
export default {
  name: 'truck-system',
  components: {
    AddTruck,
    Modal,
    Icon
  },
  data () {
    return {
      types: [{id: 1, name: 'load'}, {id: 2, name: 'download'}],

      infoShipper: false,
      exists: false,

      shipment: {},

      currentShipment: undefined,
      id: undefined,

      info: ''
    }
  },
  methods: {
    ...mapActions({
      saveExpedition: 'expeditions/patch',
      getExpedition: 'expeditions/read',
      saveReception: 'receptions/patch',
      getReception: 'receptions/read'
    }),
    existShipment () {
      if (this.shipment.type === 1) this.getExpedition(this.shipment.reference).then(response => { this.currentShipment = response })
      else this.getReception(this.shipment.reference).then(response => { this.currentShipment = response })
    },
    updateShipment (truck) {
      const isExpedition = this.shipment.type === 1
      const shipment = { id: this.currentShipment.id, shipper: truck.id }
      const saveMethod = isExpedition ? this.saveExpedition : this.saveReception

      saveMethod(shipment).then(response => {
        this.$notify({ group: 'global', type: 'success', duration: 4000, title: 'Success', text: this.$t('truck_register') })

        const infoWarehouse = `${this.$t('')}: ${this.$t('warehouse')}: ${response.warehouse}\n${this.$t('loading_dock')}${response.road}.`
        this.info = response.warehouse ? infoWarehouse : this.$t('info_truck')

        this.infoShipper = true
        setTimeout(() => { this.infoShipper = false }, 60000)

        this.currentShipment = undefined
        this.shipment = {}
      })
    }
  }
}
</script>
<style scoped lang="scss">
#truck-system {
  display: table;
  min-width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageTruckSystem.vue